export interface FiltrosProps {
  label: string;
  value: string;
}

export const filtros = (t: any): Array<FiltrosProps> => [
  {
    label: t("tasks.filters.today"),
    value: "hoje",
  },
  {
    label: t("tasks.filters.tomorrow"),
    value: "amanha",
  },
  {
    label: t("tasks.filters.this_week"),
    value: "semana",
  },
  {
    label: t("tasks.filters.in_progress"),
    value: "emAndamento",
  },
  {
    label: t("tasks.filters.completed"),
    value: "concluidas",
  },
  {
    label: t("tasks.filters.pending"),
    value: "pendentes",
  },
  {
    label: t("tasks.filters.reimbursement"),
    value: "reembolso",
  },
];

export interface StatusConfigProps {
  name: string;
  color: string;
  status: any;
  bgColor: string;
}

export const statusConfig = (t: any): Array<StatusConfigProps> => [
  {
    status: 1,
    name: t("tasks.status.pending_tasks"),
    color: "#FF5959",
    bgColor: "bg-[#FF5959]",
  },
  {
    status: 2,
    name: t("tasks.status.completed_tasks"),
    color: "#7ADC2E",
    bgColor: "bg-[#7ADC2E]",
  },
  {
    status: 3,
    name: t("tasks.status.started_tasks"),
    color: "#153DCE",
    bgColor: "bg-[#153DCE]",
  },
];
